import Button from "components/Form/Button";
import InputNew from "components/Form/InputNew";
import Otp from "components/atoms/Otp/Otp";
import Timer from "components/atoms/Timer/Timer";
import { useResetPasswordContext } from "context/ResetPasswordContext";
import hidePartOfEmail from "utils/helpers/hidePartOfEmail";
import { useLang } from "hooks/useLang";

const ResetPasswordOTP = () => {
  const { t } = useLang();
  const {
    form,
    onChange,
    requestOTP,
    restartTimer,
    setRestartTimer,
    sendOTP,
    isLoading,
    errorForm,
    OTPVerified,
    resetUserPassword,
  } = useResetPasswordContext();

  const isFilled = (arr: string[]) =>
    arr.every((value) => value !== null && value !== undefined && value !== "");

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-2 text-center">
        <h1 className="text-center text-2xl font-bold md:text-3xl">
          {OTPVerified ? t("btn_create_pass") : t("we_sent_otp")}
        </h1>
        <p className="text-sm md:text-base">{hidePartOfEmail(form.email)}</p>
      </div>
      <form
        onSubmit={OTPVerified ? resetUserPassword : sendOTP}
        className="flex flex-col gap-4 md:gap-5"
      >
        {!OTPVerified && (
          <>
            <Otp
              otp={form.otp}
              setOtp={(e: any) => onChange("otp", e)}
              isFilled={isFilled(form.otp)}
              isError={!!errorForm.otp}
              disabled={OTPVerified}
            />
            {restartTimer ? (
              <div className="flex items-center justify-center gap-2 text-sm">
                {t("got_the_code")}
                <span onClick={requestOTP} className="text-link">
                  {t("resend_code")}
                </span>
              </div>
            ) : (
              <Timer
                initialMinute={1}
                initialSeconds={30}
                setShowResend={setRestartTimer}
                center
              />
            )}
          </>
        )}

        {OTPVerified && (
          <>
            <InputNew
              label={t("reset_password")}
              inputID={"password_reset_password"}
              name={"password"}
              type={"password"}
              onChange={(e) => onChange("password", e.target.value)}
              value={form.password}
              error={errorForm?.password}
            />
            <InputNew
              label={t("lb_password_conf")}
              inputID={"password_reset_confirm_password"}
              name={"password"}
              type={"password"}
              onChange={(e) => onChange("confirm_password", e.target.value)}
              value={form.confirm_password}
              error={errorForm?.confirm_password}
            />
          </>
        )}

        <Button
          text={OTPVerified ? t("btn_create_pass") : t("check_otp_btn")}
          loading={isLoading}
          disabled={!isFilled(form.otp)}
          type="submit"
          className="p-2"
        />
      </form>
    </div>
  );
};

export default ResetPasswordOTP;
